import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable, { UserOptions } from 'jspdf-autotable';
import * as moment from 'moment';
import { IItbiDataFormRequest } from 'src/app/interfaces/dataFormRequest';

export interface IDataTable {
	title?: string
	contents: IContents[],
	height?: number | null,
	columns?: number,
	distanceTable?: number,
	userOptions?: UserOptions
}
interface IContents {
	title: string,
	content: string
}

export enum HeaderForms {
	Default = 'Default',
	Seplag = 'Seplag',
	Semurb = 'Semurb'
}

interface IDataALvaraPdf {
	subject: string;
	org: string;
	solicitante: any;
	form: IItbiDataFormRequest;
	description: string;
	usuarioLogado?: any;
}

@Injectable({
	providedIn: 'root'
})
export class GenerateDocumentFormService {

	private readonly ALVARA_BLUE = '#123F70';
	private readonly ALVARA_BORDER = '#D9D9D9';
	private readonly ALVARA_LIGHT = '#F5F7FA';

	constructor() { }

	renderHeader(doc: jsPDF) {
		const imgHeader = new Image();
		imgHeader.src = '../../../assets/img/documents/header-document.jpg';
		doc.addImage(imgHeader, 'jpg', 0, 0, 220, 0);
		return doc
	}

	renderFooter(doc: jsPDF) {
		const imgFooter = new Image();
		imgFooter.src = '../../../assets/img/documents/footer-document.jpg';
		doc.addImage(imgFooter, 'jpg', 0, 260, 220, 30);
		return doc
	}

	renderHeaderSeplagAndSemurb(doc: jsPDF, headerForms: HeaderForms) {
		const imgHeader = new Image();

		switch (headerForms) {
			case HeaderForms.Seplag:
				imgHeader.src = '../../../assets/img/documents/headerSeplag-document.jpg';
				break;
			case HeaderForms.Semurb:
				imgHeader.src = '../../../assets/img/documents/headerSemurb-document.jpg';
				break;
			default:
				imgHeader.src = '../../../assets/img/documents/header-document.jpg';
				break;
		}
		doc.addImage(imgHeader, 'jpg', 0, 0, 220, 0);
		return doc;
	}

	tablePdf(dataTable: IDataTable, columnsPerRow: number = 3): HTMLTableElement {
		const table = document.createElement('table');
		const tbody = document.createElement('tbody');

		if (dataTable.title) {
			const thead = document.createElement('thead');
			const headerRow = document.createElement('tr');

			const headerCell = document.createElement('th');
			headerCell.textContent = dataTable.title;
			headerCell.setAttribute('colspan', columnsPerRow.toString());
			headerRow.appendChild(headerCell);
			thead.appendChild(headerRow);
			table.appendChild(thead);
		}

		if (dataTable.contents && dataTable.contents.length > 0) {
			let count = 0;
			let tr = document.createElement('tr');

			for (let i = 0; i < dataTable.contents.length; i++) {
				let td = document.createElement("td");
				let titleSpan = document.createElement('span');
				titleSpan.textContent = dataTable.contents[i].title;
				td.appendChild(titleSpan);
				td.innerHTML += dataTable.contents[i].content;

				tr.appendChild(td);
				count++;

				if (count === columnsPerRow || i === dataTable.contents.length - 1) {
					tbody.appendChild(tr);
					tr = document.createElement('tr');
					count = 0;
				}
			}
		}
		table.appendChild(tbody);

		return table;
	}

	public haveSubject(listSubject: any[], subject: any): boolean {
		return listSubject.includes(subject);
	}

	public generateTable(doc: jsPDF, data: IDataTable[]) {
		const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
		const pageHeigth = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
		const footerHeight = 40;
		let currentY = 0;
		const meses = [
			"janeiro", "fevereiro", "março", "abril", "maio", "junho",
			"julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
		];
		let heightDate: number;
		const userOptionsDefault: UserOptions = {
			theme: 'plain',
			tableLineColor: '#CCCCCC',
			headStyles: {
				lineColor: '#CCCCCC',
				lineWidth: 0.5
			},
			tableLineWidth: 0.5,
			styles: {
				fillColor: '#FFFFFF',
				cellPadding: 3,
				overflow: 'linebreak',
				fontSize: 9,
				halign: 'justify'
			}
		};
		data.map((item, index) => {
			let userOption: UserOptions = (item.userOptions) ? item.userOptions : userOptionsDefault;
			autoTable(doc, {
				html: (item.columns) ? this.tablePdf(item, item.columns) : this.tablePdf(item),
				startY: (index == 0) ? pageHeigth / 5 : item.height,
				pageBreak: 'avoid',
				...userOption,
				didDrawPage: (table) => {
					if (index == data.length - 1) {
						heightDate = table.cursor.y + 6;
						doc.setFontSize(10);
						const date = moment();
						doc.text(`São Gonçalo do Amarante ${date.date()} de ${meses[date.month()]} de ${date.year()}.`, pageWidth / 1.1, heightDate, { align: 'right' });

						if (currentY + footerHeight > pageHeigth) {
							if (heightDate + footerHeight > pageHeigth) {
								doc.addPage();
								currentY = 0;
							}
						}

					}
					else {
						data[index + 1].height = table.cursor.y + ((item.distanceTable) ? item.distanceTable : 3);
					}
				},

			});
			currentY += (item.height || 0);
		})

		return doc;
	}

	public formatData(dataString: string) {
		if (dataString) {
			// Separando os componentes da data
			const [ano, mes, dia] = dataString.split('-').join('/').split('/');

			// Mapeando o número do mês para o nome do mês
			const meses = [
				'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
				'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
			];

			// Construindo a string formatada
			const dataFormatada = `${dia} de ${meses[parseInt(mes) - 1]} de ${ano}`;

			console.log("[formatData] dataFormatada: ", dataFormatada);

			if (dataFormatada != "undefined de undefined de ") {
				return dataFormatada;
			} else {
				return "";
			}
		}
	}

	public generateTableAlvara(doc: jsPDF, data: IDataTable[]): jsPDF {
		const pageWidth = doc.internal.pageSize.width;

		const meses = [
			"janeiro", "fevereiro", "março", "abril", "maio", "junho",
			"julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
		];
	
		let startY = 60;
		let finalY = 0;

		const userOptionsDefault: UserOptions = {
			theme: 'plain',
			tableLineColor: '#CCCCCC',
			tableLineWidth: 0.5,
			headStyles: {
				lineColor: '#CCCCCC',
				lineWidth: 0.5,
				fontSize: 9,
				fontStyle: 'bold'
			},
			styles: {
				fillColor: '#FFFFFF',
				cellPadding: 2,
				overflow: 'linebreak',
				fontSize: 8,
				halign: 'justify',
				lineColor: '#CCCCCC'
			},
			margin: {
				top: 20,
				right: 10,
				bottom: 40,
				left: 10
			}
		};

		data.forEach((item, index) => {
			const userOptions: UserOptions = item.userOptions
				? { ...userOptionsDefault, ...item.userOptions }
				: userOptionsDefault;

			autoTable(doc, {
				html: this.tablePdfAlvara(item, item.columns || 1),
				startY,
				pageBreak: 'auto',
				...userOptions,
				didDrawPage: (table) => {
					startY = table.cursor.y + 1;
					finalY = table.cursor.y;
				}
			});
		});

		const date = moment();
		doc.setFontSize(8);
		doc.text(
			`São Gonçalo do Amarante, ${date.date()} de ${meses[date.month()]} de ${date.year()}.`,
			pageWidth - 10,
			finalY + 10,
			{ align: 'right' }
		);

		return doc;
	}

	private tablePdfAlvara(dataTable: IDataTable, columnsPerRow: number = 1): HTMLTableElement {
		const table = document.createElement('table');
		table.style.width = '100%';
		table.style.borderCollapse = 'collapse';

		const tbody = document.createElement('tbody');

		if (dataTable.title) {
			const thead = document.createElement('thead');
			const headerRow = document.createElement('tr');

			const headerCell = document.createElement('th');
			headerCell.textContent = dataTable.title;
			headerCell.setAttribute('colspan', columnsPerRow.toString());
			headerCell.style.border = '0.5px solid #CCCCCC';
			headerCell.style.padding = '3px';
			headerCell.style.backgroundColor = '#f5f5f5';
			headerCell.style.fontWeight = 'bold';
			headerRow.appendChild(headerCell);
			thead.appendChild(headerRow);
			table.appendChild(thead);
		}

		if (dataTable.contents && dataTable.contents.length > 0) {
			let count = 0;
			let tr = document.createElement('tr');

			for (let i = 0; i < dataTable.contents.length; i++) {
				let td = document.createElement("td");
				td.style.border = '0.5px solid #CCCCCC';
				td.style.padding = '2px';
				td.style.verticalAlign = 'top';

				let titleSpan = document.createElement('span');
				titleSpan.textContent = dataTable.contents[i].title;
				titleSpan.style.fontWeight = 'bold';
				td.appendChild(titleSpan);

				let contentSpan = document.createElement('span');
				contentSpan.textContent = dataTable.contents[i].content;
				td.appendChild(contentSpan);

				tr.appendChild(td);
				count++;

				if (count === columnsPerRow || i === dataTable.contents.length - 1) {
					tbody.appendChild(tr);
					tr = document.createElement('tr');
					count = 0;
				}
			}
		}
		table.appendChild(tbody);

		return table;
	}

	public generateTableSemurb(doc: jsPDF, data: IDataTable[]) {

		const pageWidth = doc.internal.pageSize.getWidth();
		const pageHeight = doc.internal.pageSize.getHeight();
		const footerHeight = 40;
	
		const meses = [
			"janeiro", "fevereiro", "março", "abril", "maio", "junho",
			"julho", "agosto", "setembro", "outubro", "novembro", "dezembro"
		];
	
		const defaultOptions: UserOptions = {
			theme: 'plain',
			tableLineColor: '#CCCCCC',
			headStyles: {
				lineColor: '#CCCCCC',
				lineWidth: 0.5
			},
			tableLineWidth: 0.5,
			styles: {
				fillColor: '#FFFFFF',
				cellPadding: 3,
				overflow: 'linebreak',
				fontSize: 9,
				halign: 'justify'
			}
		};
	
		let startY = pageHeight / 5;
	
		data.forEach((item, index) => {
	
			const userOptions: UserOptions = item.userOptions ?? defaultOptions;
	
			autoTable(doc, {
				html: item.columns
					? this.tablePdf(item, item.columns)
					: this.tablePdf(item),
	
				startY: startY,
				pageBreak: 'auto',
	
				...userOptions,
	
				didDrawPage: (table) => {
	
					if (index === data.length - 1) {
	
						const cursorY = table.cursor.y + 6;
	
						if (cursorY + footerHeight > pageHeight) {
							doc.addPage();
							startY = 10;
						}
	
						doc.setFontSize(10);
	
						const date = moment();
	
						doc.text(
							`São Gonçalo do Amarante ${date.date()} de ${meses[date.month()]} de ${date.year()}.`,
							pageWidth - 10,
							cursorY,
							{ align: 'right' }
						);
					}
				}
			});
	
			const finalY = (doc as any).lastAutoTable.finalY;
	
			startY = finalY + (item.distanceTable ?? 5);
	
			if (startY + footerHeight > pageHeight) {
				doc.addPage();
				startY = 20;
			}
	
		});
	
		return doc;
	}

	private drawSectionTitle(
		doc: jsPDF,
		title: string,
		y: number
	) {
		doc.setFillColor(this.ALVARA_BLUE);
		doc.rect(10, y, 190, 6, 'F');

		doc.setTextColor('#FFFFFF');
		doc.setFont('helvetica', 'bold');
		doc.setFontSize(8);

		doc.text(title.toUpperCase(), 12, y + 4);

		doc.setTextColor('#000000');
	}

	private drawCell(
		doc: jsPDF,
		label: string,
		value: string,
		x: number,
		y: number,
		w: number,
		minHeight: number = 12
	): number {
		doc.setDrawColor(this.ALVARA_BORDER);

		doc.setFont('helvetica', 'bold');
		doc.setFontSize(8);

		const labelHeight = 4;

		doc.setFont('helvetica', 'normal');
		doc.setFontSize(9);

		const lines = doc.splitTextToSize(
			value || 'Não informada',
			w - 4
		);

		const textHeight = lines.length * 4;

		const finalHeight = Math.max(
			minHeight,
			labelHeight + textHeight + 4
		);

		doc.rect(x, y, w, finalHeight);

		doc.setFont('helvetica', 'bold');
		doc.text(label.toUpperCase(), x + 2, y + 3);

		doc.setFont('helvetica', 'normal');
		doc.text(lines, x + 2, y + 7);

		return finalHeight;
	}

	private ensureAlvaraPage(
		doc: jsPDF,
		y: number,
		neededHeight: number,
		startY: number = 20
	): number {
		const pageHeight = doc.internal.pageSize.getHeight();
		const bottomMargin = 15;

		if (y + neededHeight > pageHeight - bottomMargin) {
			doc.addPage();
			return startY;
		}

		return y;
	}

	public generateLayoutAlvara( doc: jsPDF, data: IDataALvaraPdf) {
		let y = 42;

		// TÍTULO
		y = this.ensureAlvaraPage(doc, y, 13);

		doc.setFillColor(this.ALVARA_BLUE);
		doc.rect(10, y, 190, 10, 'F');

		doc.setTextColor('#FFFFFF');
		doc.setFont('helvetica', 'bold');
		doc.setFontSize(11);

		const titleLines = doc.splitTextToSize(
			data.subject.toUpperCase(),
			170
		);

		doc.text(
			titleLines,
			105,
			y + 6,
			{ align: 'center' }
		);

		doc.setTextColor('#000000');

		y += 15;

		// DADOS DO SOLICITANTE
		y = this.ensureAlvaraPage(doc, y, 50);

		this.drawSectionTitle(doc, 'DADOS DO SOLICITANTE', y);

		y += 6;

		this.drawCell(
			doc,
			'IDENTIFICAÇÃO',
			`${this.formatCpfCnpj(data.usuarioLogado.SOLR_CpfCnpj)} - ${data.usuarioLogado.SOLR_NomeRazaoSocial}`,
			10,
			y,
			190,
			14
		);

		y += 14;

		this.drawCell(
			doc,
			'MICROEMPREENDEDOR INDIVIDUAL (MEI)',
			data.form.SOLAL_SouMEI === true ? 'Sim' : 'Não',
			10,
			y,
			190,
			12
		);

		y += 12;

		this.drawCell(
			doc,
			'SUBSTITUTO TRIBUTÁRIO',
			data.form.SOLAL_SubstitutoTributario === 'SIM'
				? 'Sim'
				: 'Não',
			10,
			y,
			63,
			12
		);

		this.drawCell(
			doc,
			'INSCRIÇÃO MUNICIPAL',
			data.form.SOLAL_InscricaoMunicipal || 'Não informada',
			73,
			y,
			63,
			12
		);

		this.drawCell(
			doc,
			'INÍCIO ATIVIDADE MUNICÍPIO',
			this.formatDate(
				data.form.SOLAL_InicioAtividadeMunicipio
			),
			136,
			y,
			64,
			12
		);

		y += 12;

		this.drawCell(
			doc,
			'INÍCIO ATIVIDADE RFB',
			this.formatDate(data.form.SOLAL_InicioAtividadeRFB),
			10,
			y,
			63,
			12
		);

		this.drawCell(
			doc,
			'E-MAIL',
			data.usuarioLogado.SOLR_Email,
			73,
			y,
			127,
			12
		);

		y += 12;

		this.drawCell(
			doc,
			'TELEFONE',
			this.formatTelefone(data.usuarioLogado.SOLR_Telefone),
			10,
			y,
			63,
			12
		);

		this.drawCell(
			doc,
			'ENDEREÇO',
			`${data.form.SOLAL_Logradouro}, ${data.form.SOLAL_Numero}` +
				`${data.form.SOLAL_Complemento ? ', ' + data.form.SOLAL_Complemento : ''}, ` +
				`${data.form.SOLAL_Bairro}, ${data.form.SOLAL_Municipio} - ` +
				`${this.formatCEP(data.form.SOLAL_CEP)}`,
			73,
			y,
			127,
			12
		);

		y += 16;

		// DADOS DO REQUERENTE
		if (
			data.usuarioLogado.SOLR_CpfCnpj !==
			data.solicitante.SOLR_CpfCnpj
		) {
			y = this.ensureAlvaraPage(doc, y, 34);

			this.drawSectionTitle(doc, 'DADOS DO REQUERENTE', y);

			y += 6;

			this.drawCell(
				doc,
				'IDENTIFICAÇÃO',
				`${this.formatCpfCnpj(data.solicitante.SOLR_CpfCnpj)} - ${data.solicitante.SOLR_NomeRazaoSocial}`,
				10,
				y,
				190,
				14
			);

			y += 14;

			this.drawCell(
				doc,
				'E-MAIL',
				data.solicitante.SOLR_Email,
				10,
				y,
				95,
				12
			);

			this.drawCell(
				doc,
				'TELEFONE',
				this.formatTelefone(data.solicitante.SOLR_Telefone),
				105,
				y,
				95,
				12
			);

			y += 16;
		}

		// DADOS DO IMÓVEL
		y = this.ensureAlvaraPage(doc, y, 36);

		this.drawSectionTitle(
			doc,
			'DADOS DO IMÓVEL ONDE SERÁ LICENCIADA A ATIVIDADE',
			y
		);

		y += 6;

		this.drawCell(
			doc,
			'INSCRIÇÃO IPTU',
			data.form.SOLAL_InscricaoIPTU || 'Não informada',
			10,
			y,
			63,
			12
		);

		this.drawCell(
			doc,
			'ÁREA TOTAL UTILIZADA',
			`${data.form.SOLAL_AreaTotal} m²`,
			73,
			y,
			63,
			12
		);

		this.drawCell(
			doc,
			'MUNICÍPIO',
			data.form.SOLAL_ImovelMunicipio,
			136,
			y,
			64,
			12
		);

		y += 12;

		this.drawCell(
			doc,
			'ENDEREÇO DO IMÓVEL',
			`${data.form.SOLAL_ImovelLogradouro}, ${data.form.SOLAL_ImovelNumero}` +
				`${data.form.SOLAL_ImovelComplemento ? ', ' + data.form.SOLAL_ImovelComplemento : ''}, ` +
				`${data.form.SOLAL_ImovelBairro}, ${data.form.SOLAL_ImovelMunicipio} - ` +
				`${this.formatCEP(data.form.SOLAL_ImovelCEP)}`,
			10,
			y,
			190,
			14
		);

		y += 18;

		// DADOS DAS ATIVIDADES
		y = this.ensureAlvaraPage(doc, y, 16);

		this.drawSectionTitle(
			doc,
			'DADOS DAS ATIVIDADES',
			y
		);

		y += 8;

		data.form.atividades?.forEach((atividade, index) => {
			y = this.ensureAlvaraPage(doc, y, 40);

			doc.setFillColor(this.ALVARA_LIGHT);
			doc.rect(10, y, 190, 5, 'F');

			doc.setFont('helvetica', 'bold');
			doc.setFontSize(9);

			doc.text(`ATIVIDADE ${index + 1}`, 12, y + 3.5);

			y += 5;

			this.drawCell(
				doc,
				'CNAE',
				atividade.SOLAL_CNAE || '',
				10,
				y,
				50,
				12
			);

			this.drawCell(
				doc,
				'DESCRIÇÃO',
				atividade.SOLAL_DescricaoAtividade || '',
				60,
				y,
				140,
				12
			);

			y += 12;

			this.drawCell(
				doc,
				'ESPÉCIE DE CONTRIBUINTE',
				this.getEspecieContribuinteAlvaraLabel(
					atividade.SOLAL_EspecieContribuinte
				),
				10,
				y,
				95,
				12
			);

			this.drawCell(
				doc,
				'TIPO DE TRIBUTAÇÃO',
				this.getTipoTributacaoAlvaraLabel(
					atividade.SOLAL_TipoTributacao
				),
				105,
				y,
				95,
				12
			);

			y += 16;
		});

		// RESPONSÁVEL CONTÁBIL
		if (
			data.form.SOLAL_ContabilNome ||
			data.form.SOLAL_ContabilCPFCNPJ ||
			data.form.SOLAL_ContabilCRC
		) {
			y = this.ensureAlvaraPage(doc, y, 34);

			this.drawSectionTitle(
				doc,
				'RESPONSÁVEL CONTÁBIL',
				y
			);

			y += 6;

			this.drawCell(
				doc,
				'NOME / RAZÃO SOCIAL',
				data.form.SOLAL_ContabilNome ||
					'Não informado',
				10,
				y,
				190,
				12
			);

			y += 12;

			this.drawCell(
				doc,
				'CPF/CNPJ',
				data.form.SOLAL_ContabilCPFCNPJ
					? this.formatCpfCnpj(
							data.form.SOLAL_ContabilCPFCNPJ
					)
					: 'Não informado',
				10,
				y,
				95,
				12
			);

			this.drawCell(
				doc,
				'CRC',
				data.form.SOLAL_ContabilCRC ||
					'Não informado',
				105,
				y,
				95,
				12
			);

			y += 16;
		}

		// SÓCIOS
		if (
			data.form.socios &&
			data.form.socios.length > 0
		) {
			y = this.ensureAlvaraPage(doc, y, 16);

			this.drawSectionTitle(doc, 'SÓCIOS', y);

			y += 8;

			data.form.socios.forEach((socio, index) => {
				y = this.ensureAlvaraPage(doc, y, 24);

				doc.setFillColor(this.ALVARA_LIGHT);
				doc.rect(10, y, 190, 5, 'F');

				doc.setFont('helvetica', 'bold');
				doc.setFontSize(9);

				doc.text(`SÓCIO ${index + 1}`, 12, y + 3.5);

				y += 5;

				this.drawCell(
					doc,
					'CPF/CNPJ',
					this.formatCpfCnpj(
						socio.SOLAL_SocioCPFCNPJ
					),
					10,
					y,
					70,
					12
				);

				this.drawCell(
					doc,
					'NOME',
					socio.SOLAL_SocioNome,
					80,
					y,
					120,
					12
				);

				y += 16;
			});
		}

		// RESPONSÁVEL LEGAL
		if (
			data.form.SOLAL_ResponsavelNome ||
			data.form.SOLAL_ResponsavelCPF ||
			data.form.SOLAL_ResponsavelQualificacao
		) {
			y = this.ensureAlvaraPage(doc, y, 34);

			this.drawSectionTitle(
				doc,
				'RESPONSÁVEL LEGAL DA PESSOA JURÍDICA',
				y
			);

			y += 6;

			this.drawCell(
				doc,
				'NOME',
				data.form.SOLAL_ResponsavelNome ||
					'Não informado',
				10,
				y,
				190,
				12
			);

			y += 12;

			this.drawCell(
				doc,
				'CPF',
				data.form.SOLAL_ResponsavelCPF
					? this.formatCpfCnpj(
							data.form.SOLAL_ResponsavelCPF
					)
					: 'Não informado',
				10,
				y,
				95,
				12
			);

			this.drawCell(
				doc,
				'QUALIFICAÇÃO',
				data.form.SOLAL_ResponsavelQualificacao ||
					'Não informado',
				105,
				y,
				95,
				12
			);

			y += 16;
		}

		// DESCRIÇÃO DA SOLICITAÇÃO
		y = this.ensureAlvaraPage(doc, y, 28);

		this.drawSectionTitle(
			doc,
			'DESCRIÇÃO DA SOLICITAÇÃO',
			y
		);

		y += 6;

		const descHeight = this.drawCell(
			doc,
			'',
			data.description || '',
			10,
			y,
			190,
			20
		);

		y += descHeight + 4;

		// DECLARAÇÕES
		y = this.ensureAlvaraPage(doc, y, 15);

		this.drawSectionTitle(
			doc,
			'DECLARAÇÕES DO REQUERENTE',
			y
		);

		y += 9;

		doc.setFont('helvetica', 'normal');
		doc.setFontSize(8);

		const declarations = [
			'O requerente, profissional autônomo ou representante legal da empresa acima indicada, declara que:',
			'Todas as informações e documentos que instruem o presente processo de alvará de localização e funcionamento são a expressão da verdade, e que responderá civil e criminalmente, nos termos da legislação em vigor, por omissões e fatos controversos que venham a ser, posteriormente, apurados, isentando a Prefeitura Municipal de São Gonçalo do Amarante de quaisquer responsabilidades pelos mesmos, assumindo inclusive eventuais danos causados a terceiros;',
			'Está ciente de que a apuração de qualquer irregularidade implicará na cassação do alvará de localização e funcionamento, na interdição do estabelecimento e na aplicação de multas cabíveis, sem prejuízo das demais penalidades aplicáveis;',
			'Será responsável pelo presente termo, mesmo em caso de transferência do estabelecimento, até que sejam tomadas as providências para alteração do alvará de localização e funcionamento;',
			'A edificação em que se encontra instalada a atividade a ser licenciada possui laudo técnico, emitido por profissional habilitado, que atesta a eficiência do sistema de prevenção e combate a incêndio e pânico, instalado conforme legislação vigente;',
			'Está ciente de que o alvará de localização e funcionamento não dispensa o atendimento aos dispositivos legais de prevenção e combate a incêndio, junto ao Corpo de Bombeiros;',
			'Em caso de edificação condominial, responsabiliza-se pela instalação e pelo funcionamento da referida atividade nos termos da convenção do condomínio e do Código Civil;',
			'Está apto ao exercício da atividade ora requerida, nos termos da legislação que regulamenta a referida profissão, bem como está ciente de seus deveres e obrigações junto a conselhos e órgãos de classe, no caso de atividades vinculadas aos mesmos.'
		];

		declarations.forEach((text, index) => {
			const content =
				index === 0
					? text
					: `${index}. ${text}`;

			const lines = doc.splitTextToSize(
				content,
				180
			);

			const blockHeight = lines.length * 4;

			y = this.ensureAlvaraPage(
				doc,
				y,
				blockHeight + 2
			);

			doc.text(lines, 14, y);

			y += blockHeight + 2;
		});

		return doc;
	}

	public formatTelefone(telefone: string): string {
		if (!telefone) return '';

		const digitsOnly = telefone.replace(/\D/g, '');

		if (digitsOnly.length === 11) {
			return digitsOnly.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
		}

		if (digitsOnly.length === 10) {
			return digitsOnly.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
		}

		return telefone;
	}

	public formatCEP(cep: string): string {
		if (!cep) return '';

		const digitsOnly = cep.replace(/\D/g, '');

		if (digitsOnly.length === 8) {
			return digitsOnly.replace(/^(\d{5})(\d{3})$/, '$1-$2');
		}

		return cep;
	}

	public formatCpfCnpj(cpfCnpj: string): string {
		if (!cpfCnpj) return '';

		const digitsOnly = cpfCnpj.replace(/\D/g, '');

		if (digitsOnly.length === 11) {
			return digitsOnly.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
		}

		if (digitsOnly.length === 14) {
			return digitsOnly.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
		}

		return cpfCnpj;
	}

	private getEspecieContribuinteAlvaraLabel(value: string): string {
		const labels = {
			'EMPRESA': 'Empresa',
			'AUTONOMO': 'Autônomo',
			'SUBSTITUTO': 'Substituto',
			'EQUIPARADA': 'Equiparada a empresa',
			'RESPONSAVEL': 'Responsável',
			'OUTRO_MUNICIPIO': 'De outro município'
		};
		return labels[value] || value || 'Não informado';
	}

	private getTipoTributacaoAlvaraLabel(value: string): string {
		const labels = {
			'RECEITA': 'Receita',
			'ESTIMATIVA': 'Estimativa',
			'PROFISSIONAL': 'Profissional',
			'PRIMARIO': 'Primário',
			'MEDIO': 'Médio',
			'SUPERIOR': 'Superior',
			'MOTORISTA': 'Motorista',
			'NENHUM': 'Nenhum'
		};
		return labels[value] || value || 'Não informado';
	}

	public formatDate(dateString: string): string {
		if (!dateString) return dateString;

		const [year, month, day] = dateString.split('-');
		return `${day}/${month}/${year}`;
	}
}
